export default __webpack_public_path__ + "static/media/2.ad04d35a.jpg";